import { required, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      name: {
        required: helpers.withMessage(i18n.global.t('Please enter a category name.'), required)
      }
    }
  }
};
